/*
* Redirecting German visitors to German pages
*
* Terms & Conditions - AGB
* Imprint - Impressum
* Privacy Policy - Datenschutzerklärung
* Returns/Right of withdrawal - Widerrufsrecht
*/

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookieInSeconds(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCountryCode(){

  return getCountryCodeNew();

//   var ipinfo = getCookie('malaika-ipinfo');

//   if(!ipinfo){

//     $.get("https://ipinfo.io?token=38aeecafdd9f6e", function(response) {

//       var countryCode = response.country;

//       $('body').attr('countryCode', countryCode);
//       setCookie('malaika-ipinfo', countryCode, 30);
//       return countryCode;

//     }, "jsonp");
//   }
//   else{
//     return ipinfo;
//   }
}

function getCountryCodeNew(){

  var ipinfo = getCookie('malaika-ipinfo');

  if(!ipinfo){

    $.getJSON('https://json.geoiplookup.io/?callback=?', function(data) {

      var countryCode = data.country_code;

      $('body').attr('countryCode', countryCode);
      setCookie('malaika-ipinfo', countryCode, 30);
      return countryCode;

    }, "jsonp");
  }
  else{
    return ipinfo;
  }
}

function locationRedirect(countryCode){

  var QueryString = (new URL(location.href)).searchParams.get('noredirect');

  if(QueryString == 'true'){
    setCookie('malaika-noredirect', 'true', 1);
  }

  var noRedirect = getCookie('malaika-noredirect');

  if(countryCode == 'EG' || countryCode == 'EE'){
  // if(countryCode == 'EG' || countryCode == 'EE' || countryCode == 'MN'){
    if(!noRedirect)
    window.location.href = 'https://egypt.malaikalinens.com';
  }

  // If visitors are from Germany, we'll redirect them to German versions of pages.
  if(countryCode == 'DE' || countryCode == 'MN' ||
     countryCode == 'AT' || countryCode == 'CH'){

    // Fetching product handle
    var url = window.location.href
    var handle = url.substr(url.lastIndexOf('/') + 1);

    // English page URI handles
    var redirectMap = ['imprint','privacy-policy','terms-conditions','returns'];

    // Redirect if current page is in Redirect List
    for(var i = 0; i <= redirectMap.length; i++){
      if(handle == redirectMap[i]){
        // Redirecting
        window.location.href = window.location.href + '-deutsch';
      }
    }
  }
}

// Shows US navigation for US visitors
function locationBasedNavigation(countryCode){

  return;

  var navUS = document.getElementById("main-nav-us");;
  var navDefault = document.getElementById('main-nav-default');

  navUS.style.display = 'none';
  navDefault.style.display = 'block';
  setTimeout(function(){
    navUS.style.opacity = '0';
    navDefault.style.opacity = '1';
  }, 50);

  return;

  if(countryCode == 'US' || countryCode == 'MN'){
    navUS.style.display = 'block';
    navDefault.style.display = 'none';
    setTimeout(function(){
      navUS.style.opacity = '1';
      navDefault.style.opacity = '0';
    }, 50);
  }
  else{
    navUS.style.display = 'none';
    navDefault.style.display = 'block';
    setTimeout(function(){
      navUS.style.opacity = '0';
      navDefault.style.opacity = '1';
    }, 50);
  }
}

function locationBasedCurrency(countryCode){

  if(countryCode == 'US'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'USD'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'USD', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'USD') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }
  else if(countryCode == 'CH'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'CHF'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'CHF', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'CHF') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }
  else if(countryCode == 'JP'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'JPY'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'JPY', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'JPY') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }
  else if(countryCode == 'UK'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'GBP'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'GBP', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'GBP') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }

  else if(countryCode == 'AU'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'AUD'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'AUD', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'AUD') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }

  else if(countryCode == 'CA'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'CAD'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'CAD', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'CAD') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }
  else if(countryCode == 'HK'){
    var dropdown = $('#currency_form');
    if(dropdown.val() != 'HKD'){
      var chosenCurr = getCookie('malaika-chosen-currency');
      if(!chosenCurr){
        setCookie('malaika-chosen-currency', 'HKD', 1);
        // changing currency option
        $("#currency_form option").each(function() {
          if($(this).text() == 'HKD') {
            $(this).attr('selected', 'selected');
            dropdown.submit();
          }
        });
      }
    }
  }
}


function _DOMContentLoaded(){

  var countryCode = getCountryCode();

  if(typeof(countryCode) != 'string'){
    setTimeout(function(){
      _DOMContentLoaded();
    }, 100);
  }
  else{
    if(typeof(countryCode) == 'object'){
      countryCode = countryCode.responseJSON['country'];
    }
    DOMFunctions(countryCode);
  }

  function DOMFunctions(countryCode){

    $.getJSON('https://json.geoiplookup.io/?callback=?', function(data) {
      var cc = data.country_code;

      // locationRedirectEg(cc);

      // others
      locationRedirect(cc);
      locationBasedNavigation(cc);
      locationBasedCurrency(cc);

    });

  }
}
document.addEventListener("DOMContentLoaded", _DOMContentLoaded);

// function locationRedirectEg(cc){
//   var arr = [
//     'EE','EG'
//   ];
//
//   if ( $.inArray(cc, arr) > -1 )
//     window.location.replace("//egypt.malaikalinens.com");
// }
